import React from 'react';
import Select from 'react-select';
import { useField } from 'formik';


function SelectSearchField({ form, ...props }) {
    const [field, state, { setValue, setTouched }] = useField(props.field.name);

    const onChange = (update) => {
        console.log(update)
        if (update == null) {
            setValue(update);
            
            if (props.onChange) {
                props.onChange(update, form);
            }
            return;
        }
        
        if (update.value != undefined) {
            setValue(update.value);

            if (props.onChange) {
                props.onChange(update.value, form);
            }
        }
        else {
            const values = update.map(update => update.value);

            setValue(values);

            if (props.onChange) {
                props.onChange(values);
            }
        }
    };

    const getDefaultValue = () => {
        if (!Array.isArray(props.field.value)) {
            let selected = props.options.filter(option => option.value == props.field.value);
            if (selected.length > 0) {
                return selected[0];
            }
        }
        else if (Array.isArray(props.field.value)) {
            let selected = props.options.filter(option => props.field.value.includes(option.value));
            return selected

        }
        return undefined;
    }

    return (
        <div className="form-group">
            {props.label &&
                <label>{props.label}</label>
            } 
            <Select value={getDefaultValue()}
                {...props}
                onChange={onChange}
                onBlur={setTouched} />
        </div>
    )
}

export default SelectSearchField;

//Used like this:
// <Field component={SelectField} name="fieldname" options={options}/>
// const options = [
//    { value: 1, label: 'text' },
//    ...
//  ]
